import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import SignUp from '@/views/users/sign_up/index.vue';
import SignUpFromStudio from '@/views/users/sign_up_from_studio/index.vue';
import SignIn from '@/views/users/sign_in/index.vue';
import Wait from '@/views/users/wait/index.vue';
import WaitFromStudio from '@/views/users/wait_from_studio/index.vue';
import PasswordNew from '@/views/users/password/new/index.vue';
import PasswordWait from '@/views/users/password/wait/index.vue';
import PasswordEdit from '@/views/users/password/edit/index.vue';

const routes: Array<RouteRecordRaw> = [
  // 新規会員登録
  {
    path: '/users/sign_up',
    name: 'users_sign_up',
    component: SignUp,
    props: true
  },
  // ログイン
  {
    path: '/users/sign_in',
    name: 'users_sign_in',
    component: SignIn,
    props: true
  },
  // studioから会員登録
  {
    path: '/users/sign_up_from_studio',
    name: 'users_sign_up_from_studio',
    component: SignUpFromStudio,
    props: true
  },
  // 仮登録メール送信完了
  {
    path: '/users/wait',
    name: 'users_wait',
    component: Wait
  },
  // studioから仮登録メール送信完了
  {
    path: '/users/wait_from_studio',
    name: 'users_wait_from_studio',
    component: WaitFromStudio
  },
  // パスワード再設定 アドレス入力
  {
    path: '/users/password/new',
    name: 'users_password_new',
    component: PasswordNew,
    props: true
  },
  // パスワード再設定メール送信完了
  {
    path: '/users/password_wait',
    name: 'users_password_wait',
    component: PasswordWait
  },
  // パスワード再設定
  {
    path: '/users/password/edit',
    name: 'users_password_edit',
    component: PasswordEdit
  },
  // サービストップページ
  {
    path: '/',
    name: 'top',
    beforeEnter: () => {
      window.location.href = process.env.VUE_APP_ONECAREER_PLUS_ORIGIN;
    },
    redirect: null
  },
  // 利用規約
  {
    path: '/infos/terms',
    name: 'infos',
    beforeEnter: () => {
      window.location.href = `${process.env['VUE_APP_ONECAREER_PLUS_ORIGIN']}/infos/terms`;
    },
    redirect: null
  },
  // プライバシーポリシー
  {
    path: '/privacy',
    name: 'privacy',
    beforeEnter: () => {
      window.location.href = 'https://onecareer.co.jp/privacy/';
    },
    redirect: null
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not_fount',
    redirect: {
      name: 'users_sign_in',
      params: {
        errorMessage: 'お探しのページは見つかりませんでした。'
      }
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
